<template>
  <div :class="classInput">
    <div class="form-group">
      <label class="label" :class="{'required': isRequired}">{{ label }}</label>
      <input
        :value="isoValue"
        type="datetime-local"
        class="form-control"
        :class="{'is-invalid': isInvalid}"
        @blur="() => validate()"
        @input="inputHandle($event)"
      >
      <div
        v-if="isInvalid"
        class="invalid-feedback"
      >
        <span v-if="isInvalid">Data e hora obrigatória.</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    typeInput: {
      type: String
    },
    value: {
      type: String
    },
    classInput: {
      type: String,
      required: true
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    forceShowError: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isInvalid: false,
      hasTouched: false
    }
  },
  computed: {
    isoValue () {
      if (!this.value) return ''
      var v = String(this.value)
      // Já está no formato esperado pelo input datetime-local: YYYY-MM-DDTHH:MM
      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(v)) {
        return v.substring(0, 16)
      }
      // Veio com espaço em vez de T (ex: "2026-05-25 10:30:00")
      if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(v)) {
        return v.substring(0, 10) + 'T' + v.substring(11, 16)
      }
      // Veio só a data — completa com hora zero pra renderizar
      if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
        return v + 'T00:00'
      }
      // Formato BR "DD/MM/YYYY HH:MM"
      if (/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}/.test(v)) {
        var datePart = v.substring(0, 10).split('/')
        return datePart[2] + '-' + datePart[1] + '-' + datePart[0] + 'T' + v.substring(11, 16)
      }
      // Formato BR só data "DD/MM/YYYY"
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(v)) {
        var parts = v.split('/')
        return parts[2] + '-' + parts[1] + '-' + parts[0] + 'T00:00'
      }
      return v
    }
  },
  watch: {
    forceShowError (newVal) {
      if (newVal) {
        this.validate()
      }
    }
  },
  methods: {
    inputHandle (e) {
      this.hasTouched = true
      var val = e.target.value

      if (this.isInvalid && val && val !== '') {
        this.isInvalid = false
      }

      // Emite no formato nativo do datetime-local: YYYY-MM-DDTHH:MM
      this.$emit('input', val)
    },
    validate () {
      var shouldValidate = this.hasTouched || this.forceShowError
      this.isInvalid = shouldValidate && this.isRequired && (!this.value || this.value === '')
    },
    isValid () {
      this.validate()
      return !this.isInvalid
    }
  }
}
</script>
